<template>
  <van-popup v-model="openModal" @click-overlay="maskClicked">
    <div class="wrapper">
      <div class="header"><span>{{project.item}}</span><i class="icon icon-close" @click.stop="iconClicked"></i></div>
      <div class="item" v-if="project.addWarning==='1' && project.warningInfo">
        <div class="assertive">特别提醒</div>
        <p>{{project.warningInfo}}</p>
      </div>
      <div class="item" v-if="project.avoid">
        <div class="assertive">禁忌人群</div>
        <p>{{project.avoid}}</p>
      </div>
      <div class="item" v-if="project.base===1">
        <div>基础项目</div>
        <p>指当前年龄段，满足您身体最基本检查的体检项目，一般不建议删除！</p>
      </div>
      <div class="item">
        <div>检查意义</div>
        <p>{{project.inspectionSignificance||'无'}}</p>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    project: {
      type: Object,
      default: {}
    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },
  methods: {
    maskClicked (e) {
      this.$emit('maskClicked', e)
    },
    iconClicked () {
      this.$emit('iconClicked')
    }
  },
  name: 'projectDescription'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
@import "@/assets/style/variables.scss";

.van-popup {
  border-radius: 10px;
}

.wrapper {
  width: 320px;
  padding: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 30px;
  position: relative;
  span {
    font-weight: bold;
    font-size: 18px;
    &:before {
      content: ' ';
      display: block;
      position: absolute;
      bottom: 24px;
      width: 30px;
      border-bottom: 2px solid $assertive;
    }
  }
  .icon {
    font-size: 26px;
  }
}

.item {
  padding-bottom: 18px;
  div {
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 6px;
  }

  p {
    font-size: 14px;
  }
}
</style>
